// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getStorage} from "firebase/storage"
import {getAuth} from "firebase/auth"
import {getFirestore} from "firebase/firestore"
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyACW0fuhGz_X-HQ8-JAdXZHx3nIf7DL6Ic",
    authDomain: "ssss-8f56c.firebaseapp.com",
    projectId: "ssss-8f56c",
    storageBucket: "ssss-8f56c.appspot.com",
    messagingSenderId: "441126967832",
    appId: "1:441126967832:web:aae519c3c247af82df816d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Storage
const storage = getStorage(app);
// Initialize Firebase Auth
const auth = getAuth(app);
//Initialize Cloud Firestore
const db = getFirestore(app);
export {storage, auth, db};